import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Master from "./Components/Master";
import Homepage from "./Layout/Home/Homepage";
import { HrProvider } from "./Context/HRContext";
import "bootstrap/dist/css/bootstrap.css";
import { BoxProvider } from "./Context/BoxContext";
import About from "./Layout/About/About";
import Residential from "./Layout/Residential/Residential";
import Commercial from "./Layout/Commercial/Commercial";
import Structural from "./Layout/Structural/Structural";
import Civil from "./Layout/Civil/Civil";
import Interior from "./Layout/Interior/Interior";
import Exterior from "./Layout/Exterior/Exterior";
import "./App.css";
import Landscaping from "./Layout/Landscaping/Landscaping";
import Vastu from "./Layout/Vastu/Vastu";
import ScrollToTop from "./Context/ScrollToTop";
import Spinner from "./Components/Spinner";
import Project from "./Layout/Project/Project";
import Site from "./Layout/Site/Site";
import Contact from "./Layout/Contact";

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    // Disable right-click globally
    const handleContextMenu = (event) => event.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // Preload logic (unchanged)
  const preloadImages = (urls) => {
    return Promise.all(
      urls.map(
        (url) =>
          new Promise((resolve) => {
            const img = new Image();
            img.src = url;
             img.onload = () => resolve();
            img.onerror = () => {
              console.warn(`Failed to load ${url}`);
              resolve();
            };
          })
      )
    );
  };

  useEffect(() => {
    const imageUrls = [
      process.env.PUBLIC_URL + "/assets/images/building1.jpg",
      process.env.PUBLIC_URL + "/assets/images/building2.jpg",
    ];

    const loadApp = async () => {
      const minLoadingTime = new Promise(
        (resolve) => setTimeout(resolve, 1000)
      );

      try {
        await Promise.all([minLoadingTime, preloadImages(imageUrls)]);
      } catch (error) {
        console.error("Error loading images:", error);
      } finally {
        setLoading(false);
        setTimeout(() => setFadeIn(true), 100);
      }
    };

    loadApp();
  }, []);

  if (loading) {
    return <Spinner loading={loading} />;
  }

  return (
    <div className={`app-container ${fadeIn ? "fade-in" : ""}`}>
      <Router>
        <ScrollToTop />
        <HrProvider>
          <BoxProvider>
            <Routes>
              <Route path="/" element={<Master />}>
                <Route index element={<Homepage />} />
                <Route path="/About" element={<About />} />
                <Route path="/Residential" element={<Residential />} />
                <Route path="/Commercial" element={<Commercial />} />
                <Route path="/Structural" element={<Structural />} />
                <Route path="/Civil" element={<Civil />} />
                <Route path="/Interior" element={<Interior />} />
                <Route path="/Exterior" element={<Exterior />} />
                <Route path="/Landscaping" element={<Landscaping />} />
                <Route path="/Vastu" element={<Vastu />} />
                <Route path="/Project" element={<Project />} />
                <Route path="/Site" element={<Site />} />
                <Route path="/Contact" element={<Contact />} />
              </Route>
            </Routes>
          </BoxProvider>
        </HrProvider>
      </Router>
    </div>
  );
}

export default App;
